import jQuery from 'jquery';
import OverlayScrollbars from 'overlayscrollbars';

import 'overlayscrollbars/css/OverlayScrollbars.css';

class TH_OverlayScrollbars {
    constructor(element) {
        this.options = {
            overflowBehavior : {
                x : 'hidden'
            }
        };
        
        this.dom = {
            main: element
        };

        this.dom.main.addClass('th-inited');
    }

    /** Initialize an overlay scrollbar
     * 
     */
    init() {
        let specificOptions = this.dom.main.data('overlay-scrollbars');

        if (specificOptions != null) jQuery.extend(this.options, specificOptions);

        this.dom.main.data('os-scroll', new OverlayScrollbars(this.dom.main, this.options));
    }

    static initMultiple() {
        let definition = this;

        jQuery(".overlay-scrollbars:not(.th-inited)").each(function() {
            if (jQuery(this).hasClass('th-no-init')) return;

            let ScrollBar = new definition(jQuery(this));
            ScrollBar.init();
        });
    }
}


export default TH_OverlayScrollbars; 

